export const centerBetweenTwoPoints = (
  p1: THREE.Vector3,
  p2: THREE.Vector3,
  outP: THREE.Vector3
) => outP.copy(p1).add(p2).multiplyScalar(0.5);
